import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

/** Descriptions için mobil uyumlu wrapper - tablo satırları mobilde tek sütun (label üstte, content altta) */
export const ResponsiveDescriptions = styled.div`
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        .ant-descriptions-view {
            overflow-x: hidden;
        }
        .ant-descriptions-view table {
            display: block;
        }
        .ant-descriptions-view colgroup {
            display: none;
        }
        .ant-descriptions-view tbody {
            display: block;
        }
        .ant-descriptions-row {
            display: flex;
            flex-direction: column;
            border-bottom: 1px solid #f0f0f0;
        }
        .ant-descriptions-row > th,
        .ant-descriptions-row > td {
            display: block;
            width: 100% !important;
            max-width: 100% !important;
        }
        .ant-descriptions-item-label {
            background-color: #fafafa;
            font-weight: 600;
            padding: 8px 12px !important;
            border-right: none !important;
        }
        .ant-descriptions-item-content {
            padding: 8px 12px !important;
            word-break: break-word;
        }
    }
`;

export const DetailHeaderRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (min-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
`;

export const DetailTitleBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DetailTitleName = styled.div`
    font-size: 18px;
    font-weight: bold;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        font-size: 16px;
    }
`;

export const DetailActionsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    row-gap: 8px;
    column-gap: 8px;
    align-items: center;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        justify-content: flex-start;
    }
    @media (min-width: ${MOBILE_BREAKPOINT}) {
        justify-content: flex-end;
    }
`;

/** Bilgi alanları (Firma, Çalışma Şekli, Kredili, Aktif Sözleşme) gri kutu */
export const InfoCardsSection = styled.div`
    margin-top: 16px;
    padding: 20px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    width: 100%;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 16px;
    }
`;

export const InfoCardsRow = styled.div`
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    @media (min-width: 769px) and (max-width: 992px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const InfoCard = styled.div`
    text-align: center;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        padding: 8px 0;
        border-bottom: 1px solid #f0f0f0;
        &:last-child {
            border-bottom: none;
        }
    }
`;

export const InfoCardLabel = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        font-size: 12px;
    }
`;

export const InfoCardValue = styled.div`
    font-size: 14px;
    font-weight: 500;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        white-space: normal;
        word-break: break-word;
        font-size: 13px;
    }
`;

/** Müsait Kuryeler butonu sarmalayıcı - mobilde tam genişlik */
export const AvailableCouriersWrap = styled.div`
    margin-top: 20px;
    text-align: center;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        width: 100%;
        margin-top: 16px;
    }
`;
